import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const loadOrderDetail = (code) =>
  apiActionCreator({
    'endpoint': `/orders/${code}/detail`,
    'authenticated': true,
    'types': [
      ActionTypes.LOAD_ORDER_DETAIL_REQUEST,
      ActionTypes.LOAD_ORDER_DETAIL_SUCCESS,
      [
        ActionTypes.LOAD_ORDER_DETAIL_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'GET',
  });

export const selectOrder = (order) => ({
  'type': ActionTypes.SELECT_ORDER,
  'payload': order,
});
